﻿<template>
    <div class="mb-sm-4">
        <b-row :class="{'justify-content-between': true}" no-gutters>
            <b-col cols="12" lg="3" :class="[!showFilters ? 'justify-content-end' : 'justify-content-between',  'd-flex']">
                <div v-if="isMobile && showFilters" class="d-flex flex-row">
                    <img @click="openMobileFilter"
                         :alt="$t('categoryFilter')"
                         class="category-filter-icon"
                         src="/src/assets/main/categories-temporary/category-filter.svg" />
                </div>
                <div class="d-flex flex-row">
                    <div class="h6 mt-3 text-nowrap">{{ $t('sortBy') }}:</div>

                    <b-form-select class="w-auto mt-2 border-0 fs-6 shadow-none"
                                   @input="currentSortOptionChanged(true)"
                                   v-model="currentSortOption"
                                   :options="sortOptions"
                                   text-field="text"
                                   value-field="value">
                    </b-form-select>
                </div>
            </b-col>

            <b-col cols="12" lg="3" class="d-flex align-items-center justify-content-end">
                <img @click="isCompactView = true"
                     class="d-none d-md-block compact-view mt-2"
                     :alt="$t('compactView')"
                     :src="`/src/assets/main/categories-temporary/compact-${ isCompactView ? 'active-' : '' }view.svg`" />

                <img @click="isCompactView = false"
                     class="d-none d-md-block list-view mx-3 mt-2"
                     :alt="$t('listView')"
                     :src="`/src/assets/main/categories-temporary/list-${ isCompactView ? '' : 'active-' }view.svg`" />

                <div class="h6 mt-3">{{ $t('show') }}:</div>

                <b-form-select class="w-auto sort-products mt-2 border-0 fs-6 shadow-none"
                               @input="currentPageSizeChanged(true)"
                               v-model="currentPageSize"
                               :options="pageSizeOptions"
                               text-field="text"
                               value-field="value">
                </b-form-select>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { MediaPointConstant } from '@/constants/mediaPoint-constants';

    export default {
        name: 'product-view-filter',

        data() {
            return {
                isCompactView: false,
                currentPageSize: 0,
                currentSortOption: 5
            }
        },

        props: {
            pageSizeOptions: {
                type: Array,
                default: []
            },

            sortOptions: {
                type: Array,
                default: []
            },

            showFilters: {
                type: Boolean
            }
        },

        mounted() {
            this.emitter.on("resetProductViewFilters", () => {
                this.isCompactView = false;
                this.currentPageSize = this.pageSizeOptions[0].value;
                this.currentSortOption = 5;

                this.currentPageSizeChanged(false);
                this.currentSortOptionChanged(false);
            });
        },

        computed: {
            isMobile() {
                return window.innerWidth <= MediaPointConstant.MediaPointMd;
            }
        },

        created() {
            this.currentPageSize = this.pageSizeOptions[0].value;
        },

        methods: {
            currentPageSizeChanged(reloadProducts) {
                this.$emit('change-page-size', { pageSize: this.currentPageSize, reloadProducts: reloadProducts });
            },

            currentSortOptionChanged(reloadProducts) {
                this.$emit('change-sort-option', { sortOption: this.currentSortOption, reloadProducts: reloadProducts });
            },

            openMobileFilter() {
                this.$emit('open-mobile-filter');
            }
        },

        watch: {
            isCompactView() {
                this.$emit('change-view', this.isCompactView);
            }
        }
    };
</script>